export default __webpack_public_path__ + "static/media/FONDO.00b5e960.jpg";